import React, { useCallback, useState } from "react";
import ProjectsTable from "./ProjectsTable";
import { getProjects } from "../../store/api/projects";
import { prepareParams } from "./utils";

const Projects = () => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [projects, setProjects] = useState([]);

  const fetchData = useCallback((params) => {
    setLoading(true);
    getProjects(prepareParams(params))
      .then(({ data }) => {
        setProjects(data.projects);
        setTotal(data.totalCount);
      })
      .catch(() => {
        // setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-wrapper">
      <h2 style={{ fontWeight: "bold" }}>Projects</h2>
      <ProjectsTable
        projects={projects}
        handleFetch={fetchData}
        loading={loading}
        total={total}
        showFilters={true}
      />
    </div>
  );
};

export default Projects;
